import {Component, Host, h, Prop, Event, EventEmitter, Watch} from '@stencil/core';
import {Logger} from "../../utils/logger";
import {IRequestField} from "../../interfaces/configuration";

@Component({
  tag: 'securecall-request-currency',
  styleUrl: 'securecall-request-currency.css',
  shadow: true,
})
export class SecurecallRequestCurrency {
  @Prop() fieldName: string;
  @Prop({ mutable: true }) config: IRequestField;

  @Event() isValidEvent: EventEmitter<{ field: string; valid: boolean, value: string }>;

  private readonly log = Logger('SecurecallRequestCurrency')

  public get value(): string {
    return this.config.value;
  }
  public set value(value: string) {
    if (this.config.value !== value) {
      this.config.value = value;
      this.handleLocalStorageChange();
    }
  }

  @Watch('config')
  handleConfigChange(newConfig: any, oldConfig: any) {
    if(oldConfig.value !== newConfig.value) {
      this.value = newConfig.value;
      this.validateChange(this.value);
    } else if(oldConfig.valid !== newConfig.valid) {
      this.validateChange(this.value);
    }
  }

  componentWillLoad() {
    this.validateChange(this.value);
  }

  private handleLocalStorageChange() {
    this.log.debug("handleChangeFromLocalStorage: string change:", this.value);
    this.validateChange(this.value);
  }

  handleChange(ev) {
    this.log.debug("handleChange: string change:", ev.target.value);
    this.validateChange(ev.target.value);
  }

  validateChange(input: string) {
    const num = parseFloat(input);
    const isValidCurrency = /^(\d+(\.\d{1,2})?)?$/.test(input)
    const valid = !isNaN(num) && num !== 0 && isValidCurrency
      && num >= (this.config.min || 0.01)
      && num <= (this.config.max || 99999.99);
    this.isValidEvent.emit({ field: this.fieldName, valid: valid, value: input });
  }

  render() {
    return (
      <Host>
        <div class="field-container">
          <label class="custom-label" htmlFor={this.fieldName}>{this.config.label}:
          </label>
          <input
            type="text"
            class="custom-input"
            id={this.fieldName}
            placeholder={this.config.placeholder || this.config.label}
            value={this.value}
            disabled={this.config.readOnly}
            onInput={(ev) => this.handleChange(ev)}
          />
          <div class="validity none"></div>
        </div>
      </Host>
    );
  }
}
